import { required, shape, stopOnFirstFailure, between } from '@totalsoft/pure-validations';
import { isValidDateFormat } from 'utils/simple-validations';

export const exchangeRateValidator = shape({
  currencyId: required,
  refCurrencyId: required,
  partnerId: required,
  exchangeRateDate: [required, isValidDateFormat] |> stopOnFirstFailure,
  exchangeRate1: [required, between(0, 100000)] |> stopOnFirstFailure
});
